module.exports = __webpack_public_path__ + "img/プジョー.0826e695.png";